import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';
import { ChatStatus } from 'src/types/chats';
import { FormStatus, LastTransactionStatus } from 'src/types/forms';

const NAMESPACE = 'FORMS';

i18next.addResources('es', NAMESPACE, {
  ERROR_GET_FORMS:
    'Error: no se pudieron cargar los formularios de esta sección',
  ERROR_GET_STATS_FORMS:
    'Error: no se pudieron cargar los datos de los formularios',
  ERROR_GET_FORMS_UNASSIGNED:
    'Error: no se pudieron cargar los formularios sin asignar',
  ERROR_UPDATE_FORM_AGENT:
    'Error: no pudimos actualizar las nuevas solicitudes',
  ERROR_GET_FORMS_PENDING:
    'Error: no se pudieron cargar los formularios pendientes',
  ERROR_GET_FORMS_CLOSED:
    'Error: no se pudieron cargar los formularios finalizados',
  ERROR_LOAD_SIGN: 'Error al cargar la firma digital',
  EMPTY: 'Vacío',
  UNEDITABLE_FIELD: 'Este campo no se puede editar 🔒',
  ONLY_INTEGER_FIELD: 'Este campo solo acepta numeros enteros',
  REQUESTS: 'Solicitudes',
  SELECT_MULTIPLE: 'Seleccionar varias',
  ASSIGN: 'Asignar',
  FORMS_TASKS: 'Formularios y Trámites',
  SEARCH_FORM: 'Buscar formulario',
  AVAILABLE: 'DISPONIBLES',
  COMPLETED: 'COMPLETADOS',
  BULK_ASSIGN_SUCCESS: 'Los formularios se han asignado con éxito',
  BULK_REVIEW_SUCCESS: 'Los formularios fueron revisados de forma exitosa',
  BULK_MAX_REACH: 'Solo se pueden seleccionar hasta 5 elementos',
  BULK_COMMENT_ADD_one:
    'Este comentario aplicará para el formulario seleccionado',
  BULK_COMMENT_ADD_other:
    'Este comentario aplicará para los {{ count }} formularios',
  NO_FORMS_AVAILABLE: 'No hay fomularios para esta sección',
  NO_FORMS_COMPLETED: 'No se han completado formularios hasta ahora',
  REVIEW_DOCUMENT: 'Revise el documento y complete los campos indicados.',
  MANDATORY_FIELDS: 'Aquellos obligatorios se indican con *',
  PDF_ONLY_NUMBERS: '• Solo numeros',
  PDF_COMPLETE_AND_READ:
    'Debe completar todos los campos obligatorios y leer todo el documento antes de finalizar',
  UNASSIGNED: 'Sin asignar',
  ASSIGNED: 'Asignado',
  FINALIZED: 'FINALIZADAS',
  CLOSE: 'Finalizar',
  BACK: 'Atras',
  NEXT: 'Siguiente',
  MANDATORY: '* Obligatorio',
  CHOICE_TIME: 'Seleccionar un horario',
  MANDATORY_FIELD: 'Este campo es requerido',
  DIGITAL_SIGN_INPUT: 'Pulsa para Firmar',
  DIGITAL_SIGN_TITLE: 'Firmar digitalmente',
  CHOICE_DATE: 'Seleccionar una fecha',
  DETAIL_FORM_ERROR:
    'Lo sentimos ocurrió un error al cargar el formulario, intente nuevamente.',
  SEND_FORM_SUCCESS: 'El formulario se envió exitosamente',
  EDIT_FORM_SUCCESS: 'El formulario se editó exitosamente',
  ERROR_FORM_EDIT: 'Tu respuesta ya no puede ser editada',
  SEND_FORM_ERROR:
    'Lo sentimos hubo un error el enviar el formulario, intente nuevamente',
  ERROR_COMPLETE_FORM_TITLE: 'Error de formulario',
  ERROR_COMPLETE_FORM:
    'Por favor complete todos los campos requeridos y verifique que no haya errores',
  NEED_APPROBATION: 'Estado: necesita aprobación',
  NO_NEED_APPROBATION: 'Estado: No necesita aprobación',
  [`FORM_STATUS_${FormStatus.UNASSIGNED}`]: 'Pendiente',
  [`FORM_STATUS_${FormStatus.PENDING}`]: 'Pendiente',
  [`FORM_STATUS_${FormStatus.APPROVED}`]: 'Aprobado',
  [`FORM_STATUS_${FormStatus.REJECTED}`]: 'Rechazado',
  [`FORM_STATUS_${FormStatus.CANCELLED}`]: 'Cancelado',
  [`LAST_TRANSACTION_${LastTransactionStatus.CREATED}`]:
    'Creado por {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.ASSIGNED}`]:
    'Asignado a {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.APPROVED}`]:
    'Aprobado por {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.REJECTED}`]:
    'Rechazado por {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.CANCELLED}`]: 'Cancelado',
  ASSIGN_ME_FORM: 'Asignarme',
  APPROVE_FORM: 'Aprobar',
  BULK_APPROVE: 'Aprobación masiva',
  BULK_REJECT: 'Rechazo masivo',
  TITLE_APPROVE_FORM: 'Aprobar formulario',
  TITLE_REJECT_FORM: 'Rechazar formulario',
  REJECT_FORM: 'Rechazar',
  CANCEL: 'Cancelar',
  CLOSE_FORM: 'Finalizar',
  ERROR_ASSIGNING_FORM: 'Error: no se pudo asignar la solicitud.',
  ERROR_CLOSING_FORM: 'Error: no se pudo finalizar la solicitud.',
  NO_UPLOAD_FILES:
    'Lo sentimos no hemos podido subir el archivo, intente nuevamente',
  WAIT_UPLOAD_FILE:
    'Espere que se terminen de subir los archivos para continuar',
  NO_FORM_INFO:
    'No pudimos obtener la informacion del formulario, Intente nuevamente',
  LOSE_DATA_TITLE: '¿Descartar formulario?',
  CANCEL_EDIT: '¿Cancelar edición?',
  LOSE_DATA_INFO: 'Se perderán todos los cambios',
  ERROR_LOADING_FORM: 'Error: no se pudo cargar el formulario',
  SHOW_MY_FORM: 'VER MI FORMULARIO',
  EDIT_MY_FORM: 'EDITAR MI FORMULARIO',
  SHOW_FORM: 'VER FORMULARIO',
  DOWNLOAD_ANSWER: 'Descargar respuesta',
  CANCEL_ANSWER: 'Cancelar formulario',
  CANCEL_ANSWER_DESCRIPTION:
    'Deja un comentario sobre por qué quieres cancelarlo.',
  CANCEL_ANSWER_PLACEHOLDER: 'Tu comentario',
  CANCEL_ANSWER_CONFIRM: 'Confirmar',
  ERROR_CANCEL_ANSWER: 'Error: no se pudo cancelar el formulario',
  SUCCESS_CANCEL_ANSWER: 'EL formulario se canceló con éxito',
  ASSIGNED_QUERY: '{{responsible}} ha tomado esta solicitud',
  FINALIZED_QUERY: 'Esta solicitud ha sido finalizada',
  ERROR_ASSIGN_FORM: 'Lo sentimos hubo un error al asignar el formulario',
  NO_FORM_ATTEMPTS_AVAILABLE: 'El formulario no está disponible.',
  NO_SURVEY_ATTEMPTS_AVAILABLE: 'La encuesta no está disponible.',
  SUCCESS_ASSIGN_FORM: 'El formulario se asignó con éxito',
  ERROR_ADD_COMMENT: 'Lo sentimos no hemos podido completar la solicitud',
  NOT_ASSIGNED_TO_APPROVAL_STEP:
    'El formulario ya fue asigando por otro agente',
  SUCCESS_ADD_COMMENT: 'La solicitud se completó de forma exitosa',
  ADD_COMMENT: 'Agregue un comentario...',
  FORM_MENU: 'Menú de formulario',
  FORM_DATEPICKER_PLACEHOLDER_DATE: 'Ingrese día, mes y año',
  FORM_DATEPICKER_PLACEHOLDER_MONTH_YEAR: 'Ingrese mes y año',
  ERROR_LOADING_PDF_REPORT: 'Error: no se pudo cargar el pdf del formulario.',
  SEND_FORM_TO_FINISH: 'Presiona el botón de Finalizar para continuar',
  NUMBER_INPUT_REQUIREMENTS:
    'Formato de número inválido, el correcto es:\n\n1) Solo números.\n2) Solo una separación decimal\n3) Hasta dos espacios decimales.',
  ANONYMOUS_ANSWER:
    'Esta encuesta es anónima. Todas tus respuestas se enviarán sin tu identidad.',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.UNASSIGNED}`]:
    'Se indica el tiempo restante para cumplir con el plazo esperado de asignación de este caso',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.ASSIGNED}`]:
    'Se indica el tiempo restante para cumplir con el plazo esperado de resolución de este caso',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.CLOSED}`]:
    'Se indica el tiempo utilizado en la resolución de este caso',
  CONFIRM_RE_COMPLETE_FORM:
    'Usted ya ha completado este formulario y la gestión del mismo aún no ha finalizado. ¿Está seguro qué desea volver a completarlo?',
  IN_PROGRESS: 'En progreso',
  ON_HOLD: 'En espera',
  CANCELLED: 'Cancelado',
  EXIT: 'Salir',
  CLOSED: 'Cerrado',
  SLA_RESOLUTION:
    'Se indica el tiempo restante para cumplir con la resolución de este caso.',
  SLA_ATTENTION:
    'Se indica el tiempo restante para cumplir con la atención de este caso.',
  ASSIGNED_TAB: 'ABIERTAS',
  CLOSED_TAB: 'FINALIZADAS',
  SEARCH: 'Buscar',
  NO_USER_FOUND: 'No se encontro ningún usuario con ese legajo',
  PLACEHOLDER_TEXT: 'Escribe aquí',
});

i18next.addResources('en', NAMESPACE, {
  ERROR_GET_FORMS: "Error: forms couldn't be loaded",
  ERROR_GET_STATS_FORMS: "Error: Form data could't be loaded",
  ERROR_GET_FORMS_UNASSIGNED: "Error: unassigned forms couldn't be loaded",
  ERROR_UPDATE_FORM_AGENT: "Error: we couldn't update new requests",
  ERROR_GET_FORMS_PENDING: "Error: couldn't load forms",
  ERROR_GET_FORMS_CLOSED: "Error: finalized forms couldn't load",
  ERROR_LOAD_SIGN: 'Error loading digital signature',
  EMPTY: 'Empty',
  UNEDITABLE_FIELD: 'This field can not be edited 🔒',
  ONLY_INTEGER_FIELD: 'This field only accepts integers',
  REQUESTS: 'Requests',
  SELECT_MULTIPLE: 'Select multiple',
  ASSIGN: 'Assign',
  FORMS_TASKS: 'Forms & Tasks',
  SEARCH_FORM: 'Search form',
  AVAILABLE: 'AVAILABLE',
  COMPLETED: 'COMPLETED',
  BULK_ASSIGN_SUCCESS: 'Forms have been assigned successfully',
  BULK_REVIEW_SUCCESS: 'The forms were successfully reviewed',
  BULK_MAX_REACH: 'Only up to 5 items can be selected',
  BULK_COMMENT_ADD_one: 'This comment will apply to the selected form',
  BULK_COMMENT_ADD_other: 'This comment applies to all {{ count }} forms',
  NO_FORMS_AVAILABLE: 'No forms available',
  NO_FORMS_COMPLETED: 'No forms have been completed so far',
  REVIEW_DOCUMENT: 'Review the document and complete the indicated fields.',
  MANDATORY_FIELDS: 'Mandatory ones are indicated with *',
  PDF_ONLY_NUMBERS: '• Only numbers',
  PDF_COMPLETE_AND_READ:
    'You must complete all required fields and read the entire document before finalizing',
  UNASSIGNED: 'Unassigned',
  ASSIGNED: 'Assigned',
  FINALIZED: 'FINALIZED',
  CLOSE: 'Finalize',
  BACK: 'Back',
  NEXT: 'Next',
  MANDATORY: '* Required',
  CHOICE_TIME: 'Select a time',
  MANDATORY_FIELD: 'This field is required',
  DIGITAL_SIGN_INPUT: 'Press to sign',
  DIGITAL_SIGN_TITLE: 'Sign digitally',
  CHOICE_DATE: 'Select date',
  DETAIL_FORM_ERROR:
    'Sorry, an error occurred while loading the form. Try again.',
  SEND_FORM_SUCCESS: 'The form was successfully sent',
  EDIT_FORM_SUCCESS: 'The form was successfully edited',
  ERROR_FORM_EDIT: 'Your response can no longer be edited',
  SEND_FORM_ERROR:
    'Sorry, an error occurred while sending the form. Try again.',
  ERROR_COMPLETE_FORM_TITLE: 'Form error',
  ERROR_COMPLETE_FORM:
    'Please complete all required fields and check there are no errors',
  NEED_APPROBATION: 'Status: needs approval',
  NO_NEED_APPROBATION: "Status: doesn't need approval",
  [`FORM_STATUS_${FormStatus.UNASSIGNED}`]: 'Pending',
  [`FORM_STATUS_${FormStatus.PENDING}`]: 'Pending',
  [`FORM_STATUS_${FormStatus.APPROVED}`]: 'Approved',
  [`FORM_STATUS_${FormStatus.REJECTED}`]: 'Rejected',
  [`FORM_STATUS_${FormStatus.CANCELLED}`]: 'Cancelled',
  [`LAST_TRANSACTION_${LastTransactionStatus.CREATED}`]:
    'Created by {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.ASSIGNED}`]:
    'Assigned to {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.APPROVED}`]:
    'Approved by {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.REJECTED}`]:
    'Rejected by {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.CANCELLED}`]: 'Cancelled',
  ASSIGN_ME_FORM: 'Assign me',
  APPROVE_FORM: 'Approve',
  BULK_APPROVE: 'Mass approval',
  BULK_REJECT: 'Mass rejection',
  TITLE_APPROVE_FORM: 'Approve form',
  TITLE_REJECT_FORM: 'Reject form',
  REJECT_FORM: 'Reject',
  CANCEL: 'Cancel',
  CLOSE_FORM: 'Finalize',
  ERROR_ASSIGNING_FORM: "Error: request couldn't be assigned.",
  ERROR_CLOSING_FORM: "Error: request couldn't be finalized.",
  NO_UPLOAD_FILES: "Sorry, we couldn't upload the file. Try again.",
  WAIT_UPLOAD_FILE: 'Wait for te files to finish uploading to continue.',
  NO_FORM_INFO: "We couldn't obtain the form's information. Try again.",
  LOSE_DATA_TITLE: 'Discard form?',
  CANCEL_EDIT: 'Cancel edit?',
  LOSE_DATA_INFO: 'All changes will be lost',
  ERROR_LOADING_FORM: "Error: couldn't load form",
  SHOW_MY_FORM: 'SEE MY FORM',
  EDIT_MY_FORM: 'EDIT MY FORM',
  SHOW_FORM: 'SEE FORM',
  DOWNLOAD_ANSWER: 'Download response',
  CANCEL_ANSWER: 'Cancel form',
  CANCEL_ANSWER_DESCRIPTION: 'Leave a comment about why you want to cancel.',
  CANCEL_ANSWER_PLACEHOLDER: 'Your comment',
  CANCEL_ANSWER_CONFIRM: 'Confirm',
  ERROR_CANCEL_ANSWER: 'Error: Could not cancel form',
  SUCCESS_CANCEL_ANSWER: 'The form was canceled successfully',
  ASSIGNED_QUERY: '{{responsible}} has been assigned to this request',
  FINALIZED_QUERY: 'This request has been finalized',
  ERROR_ASSIGN_FORM: 'Sorry, an error ocurred while assigning the request',
  NO_FORM_ATTEMPTS_AVAILABLE: 'The form is not available.',
  NO_SURVEY_ATTEMPTS_AVAILABLE: 'The survey is not available.',
  SUCCESS_ASSIGN_FORM: 'The form as been assigned successfully',
  ERROR_ADD_COMMENT: "Sorry, we couldn't complete the request",
  NOT_ASSIGNED_TO_APPROVAL_STEP:
    'The form was already assigned by another agent',
  SUCCESS_ADD_COMMENT: 'The request was commpleted successfully',
  ADD_COMMENT: 'Add a comment...',
  FORM_DATEPICKER_PLACEHOLDER_DATE: 'Select day, month and year',
  FORM_DATEPICKER_PLACEHOLDER_MONTH_YEAR: 'Select month and year',
  ERROR_LOADING_PDF_REPORT: "Error: couldn't load the form's pdf",
  SEND_FORM_TO_FINISH: 'Press Finish button to continue',
  NUMBER_INPUT_REQUIREMENTS:
    'Invalid number format, the correct one is:\n\n1) You can only enter numeric characters and, optionally, periods and/or comma.\n2) The separation by periods in the thousands, millions, etc. is optional.\n3) If the number has decimals, they go after the comma and must be 2.',
  ANONYMOUS_ANSWER:
    'This survey is anonymous. All your answers will be sent without your identity.',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.UNASSIGNED}`]:
    'The time remaining to meet the expected assignment deadline for this case is indicated',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.ASSIGNED}`]:
    'The time remaining to comply with the expected resolution period for this case is indicated',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.CLOSED}`]:
    'The time used to resolve this case is indicated',
  CONFIRM_RE_COMPLETE_FORM:
    'You have already completed this form and its management has not yet been completed. Are you sure you want to complete it again?',
  IN_PROGRESS: 'In progress',
  ON_HOLD: 'On hold',
  CANCELLED: 'Cancelled',
  CLOSED: 'Closed',
  EXIT: 'Exit',
  SLA_RESOLUTION:
    'Indicates the remaining time to comply with the resolution of this case',
  SLA_ATTENTION:
    'Indicates the remaining time to comply with the attention of this case',
  ASSIGNED_TAB: 'OPEN',
  CLOSED_TAB: 'FINALIZED',
  SEARCH: 'Search',
  NO_USER_FOUND: 'No user was found with that ID',
  PLACEHOLDER_TEXT: 'Write here',
});

i18next.addResources('pt', NAMESPACE, {
  ERROR_GET_FORMS: 'Erro: não foi possível carregar os formulários',
  ERROR_GET_STATS_FORMS:
    'Erro: os dados do formulário não puderam ser carregados',
  ERROR_GET_FORMS_UNASSIGNED:
    'Erro: não foi possível carregar os formulários não atribuídos',
  ERROR_UPDATE_FORM_AGENT:
    'Erro: não foi possível atualizar as novas solicitações',
  ERROR_GET_FORMS_PENDING: 'Erro: não foi possível carregar os formulários',
  ERROR_GET_FORMS_CLOSED:
    'Erro: não foi possível carregar os formulários concluídos',
  ERROR_LOAD_SIGN: 'Erro ao carregar a assinatura digital',
  EMPTY: 'Vazio',
  UNEDITABLE_FIELD: 'Este campo não pode ser editado 🔒',
  ONLY_INTEGER_FIELD: 'Este campo só aceita números inteiros',
  REQUESTS: 'Pedidos',
  SELECT_MULTIPLE: 'Selecione vários',
  ASSIGN: 'Atribuir',
  FORMS_TASKS: 'Formulários e Trâmites',
  SEARCH_FORM: 'Formulário de pesquisa',
  AVAILABLE: 'DISPONÍVEIS',
  COMPLETED: 'CONCLUÍDOS',
  BULK_ASSIGN_SUCCESS: 'Os formulários foram atribuídos com sucesso',
  BULK_REVIEW_SUCCESS: 'Os formulários foram revisados com sucesso',
  BULK_MAX_REACH: 'Apenas até 5 itens podem ser selecionados',
  BULK_COMMENT_ADD_one:
    'Este comentário será aplicado ao formulário selecionado',
  BULK_COMMENT_ADD_other:
    'Este comentário se aplica a todos os {{ count }} formulários',
  NO_FORMS_AVAILABLE: 'Não há formulários para esta seção',
  NO_FORMS_COMPLETED: 'Nenhum formulário foi preenchido até o momento',
  REVIEW_DOCUMENT: 'Revise o documento e preencha os campos indicados.',
  MANDATORY_FIELDS: 'Os obrigatórios são indicados com *',
  PDF_ONLY_NUMBERS: '• Apenas números',
  PDF_COMPLETE_AND_READ:
    'Você deve preencher todos os campos obrigatórios e ler todo o documento antes de finalizar',
  UNASSIGNED: 'NÃO ATRIBUÍDO',
  ASSIGNED: 'Atribuída',
  CLOSED: 'CONCLUÍDOS',
  CLOSE: 'Concluir',
  BACK: 'Voltar',
  NEXT: 'Próximo',
  MANDATORY: '* Obrigatório',
  CHOICE_TIME: 'Selecione um horário',
  MANDATORY_FIELD: 'Este campo é obrigatório',
  DIGITAL_SIGN_INPUT: 'Clique para assinar',
  DIGITAL_SIGN_TITLE: 'Assinar digitalmente',
  CHOICE_DATE: 'Selecione uma data',
  DETAIL_FORM_ERROR:
    'Desculpe, ocorreu um erro ao carregar o formulário. Tente novamente.',
  SEND_FORM_SUCCESS: 'O formulário foi enviado com sucesso',
  EDIT_FORM_SUCCESS: 'O formulário foi editado com sucesso',
  ERROR_FORM_EDIT: 'Sua resposta não pode mais ser editada',
  SEND_FORM_ERROR:
    'Desculpe, ocorreu um erro ao enviar o formulário. Tente novamente.',
  ERROR_COMPLETE_FORM_TITLE: 'Erro de formulário',
  ERROR_COMPLETE_FORM:
    'Preencha todos os campos obrigatórios e verifique se há erros',
  NEED_APPROBATION: 'Status: precisa de aprovação',
  NO_NEED_APPROBATION: 'Status: não precisa de aprovação',
  [`FORM_STATUS_${FormStatus.UNASSIGNED}`]: 'Pendente',
  [`FORM_STATUS_${FormStatus.PENDING}`]: 'Pendente',
  [`FORM_STATUS_${FormStatus.APPROVED}`]: 'Aprovado',
  [`FORM_STATUS_${FormStatus.REJECTED}`]: 'Rejeitado',
  [`FORM_STATUS_${FormStatus.CANCELLED}`]: 'Cancelado',
  [`LAST_TRANSACTION_${LastTransactionStatus.CREATED}`]:
    'Criado por {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.ASSIGNED}`]:
    'Atribuído a {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.APPROVED}`]:
    'Aprobavo por {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.REJECTED}`]:
    'Rejeitado por {{author}}',
  [`LAST_TRANSACTION_${LastTransactionStatus.CANCELLED}`]: 'Cancelado',
  ASSIGN_ME_FORM: 'Atribua-me',
  APPROVE_FORM: 'Aprovar',
  BULK_APPROVE: 'Aprovação em massa',
  BULK_REJECT: 'Rejeição em massa',
  TITLE_APPROVE_FORM: 'Aprovar formulário',
  TITLE_REJECT_FORM: 'Rejeitar formulário',
  REJECT_FORM: 'Rejeitar',
  CANCEL: 'Cancelar',
  CLOSE_FORM: 'Concluir',
  ERROR_ASSIGNING_FORM: 'Erro: o pedido não pode ser atribuído.',
  ERROR_CLOSING_FORM: 'Erro: o pedido não pôde ser concluído.',
  NO_UPLOAD_FILES: 'Não foi possível fazer upload do arquivo. Tente novamente.',
  WAIT_UPLOAD_FILE:
    'Aguarde até que os arquivos terminem de carregar para continuar',
  NO_FORM_INFO:
    'Não foi possível obter as informações do formulário, tente novamente',
  LOSE_DATA_TITLE: 'Descartar formulário?',
  CANCEL_EDIT: 'Cancelar edição?',
  LOSE_DATA_INFO: 'Todas as alterações serão perdidas',
  ERROR_LOADING_FORM: 'Erro: não foi possível carregar o formulários',
  SHOW_MY_FORM: 'VEJA MEU FORMULÁRIO',
  EDIT_MY_FORM: 'EDITAR MEU FORMULÁRIO',
  SHOW_FORM: 'VER FORMULÁRIO',
  DOWNLOAD_ANSWER: 'Baixar resposta',
  CANCEL_ANSWER: 'Cancelar formulário',
  CANCEL_ANSWER_DESCRIPTION:
    'Deixe um comentário sobre por que deseja cancelar.',
  CANCEL_ANSWER_PLACEHOLDER: 'Seu comentário',
  CANCEL_ANSWER_CONFIRM: 'Confirme',
  ERROR_CANCEL_ANSWER: 'Erro: Não foi possível cancelar o formulário',
  SUCCESS_CANCEL_ANSWER: 'O formulário foi cancelado com sucesso',
  ASSIGNED_QUERY: '{{responsible}} foi atribuído a esta solicitação',
  FINALIZED_QUERY: 'Este pedido foi concluído',
  ERROR_ASSIGN_FORM: 'Desculpe, ocorreu um erro ao atribuir o formulário',
  NO_FORM_ATTEMPTS_AVAILABLE: 'O formulário não está disponível',
  NO_SURVEY_ATTEMPTS_AVAILABLE: 'A pesquisa não está disponível.',
  SUCCESS_ASSIGN_FORM: 'O formulário foi atribuído com sucesso',
  ERROR_ADD_COMMENT: 'Desculpe, não foi possível concluir o pedido',
  NOT_ASSIGNED_TO_APPROVAL_STEP:
    'O formulário já foi atribuído por outro agente',
  SUCCESS_ADD_COMMENT: 'O pedido foi concluído com sucesso',
  ADD_COMMENT: 'Adicione um comentário...',
  FORM_DATEPICKER_PLACEHOLDER_DATE: 'Selecione o dia, o mês e o ano',
  FORM_DATEPICKER_PLACEHOLDER_MONTH_YEAR: 'Selecione o mês e o ano',
  ERROR_LOADING_PDF_REPORT: 'Erro: Falha ao carregar o formulário pdf',
  SEND_FORM_TO_FINISH: 'Pressione o botão Finalizar para continuar',
  NUMBER_INPUT_REQUIREMENTS:
    'Formato de número inválido, o correto é:\n\n1) Você só pode inserir caracteres numéricos e, opcionalmente, pontos e/ou vírgula.\n2) A separação por pontos em milhares, milhões, etc. é opcional.\n3) Se o número tiver decimais, eles virão após a vírgula e deverão ser 2.',
  ANONYMOUS_ANSWER:
    'Esta pesquisa é anônima. Todas as suas respostas serão enviadas sem a sua identidade.',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.UNASSIGNED}`]:
    'É indicado o tempo que falta para cumprir o prazo de resolução previsto para este caso',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.ASSIGNED}`]:
    'É indicado o tempo restante para cumprir o período de resolução esperado para este caso',
  [`REMAINING_TIME_INFORMATION_${ChatStatus.CLOSED}`]:
    'O tempo utilizado para resolver este caso é indicado',
  CONFIRM_RE_COMPLETE_FORM:
    'Você já preencheu este formulário e sua gestão ainda não foi concluída. Tem certeza de que deseja concluí-lo novamente?',
  IN_PROGRESS: 'Em andamento',
  ON_HOLD: 'Em espera',
  CANCELLED: 'Cancelada',
  EXIT: 'Sair',
  SLA_RESOLUTION:
    'Indica o tempo restante para cumprir com a resolução deste caso',
  SLA_ATTENTION:
    'Indica o tempo restante para cumprir com a atenção deste caso',
  ASSIGNED_TAB: 'ABERTAS',
  CLOSED_TAB: 'FINALIZADAS',
  SEARCH: 'Procurar',
  NO_USER_FOUND: 'Nenhum usuário foi encontrado com esse ID',
  PLACEHOLDER_TEXT: 'Escreva aqui',
});

export const useTranslation = () =>
  usei18nextTranslation([NAMESPACE, 'GENERAL']);
